import { useEffect } from 'react';

import { useLogger } from '#src/clientState/hooks';

import { useGetBuyerFromTrip } from './useGetBuyerFromTrip';
import { useGetTokenFromURL } from './useGetTokenFromURL';

export const useGetBuyerFromURL = () => {
  const { error } = useLogger();
  const token = useGetTokenFromURL();

  useEffect(() => {
    if (!token) {
      throw new Error('Token not found');
    }
  }, [token, error]);

  return useGetBuyerFromTrip({ token });
};
